// id strings for messages/voice.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const voice: Dict = {
  "voice.seo.title": "Suara AI {name}: Dengarkan & Buat Cover AI | Jammable",
  "voice.seo.description":
    "Dengarkan cover AI {name} dan buat cover-mu sendiri dalam sekitar satu menit. Pakai suara AI {name} buatan komunitas untuk lagu, teks ke suara, dan duet di Jammable.",
  "voice.seo.appName": "Generator Suara AI {name}",
  "voice.seo.private": "Suara privat | Jammable",
  "voice.name": "Suara AI {name}",

  "voice.removed": "Suara ini sudah dihapus.",
  "voice.private": "Suara ini privat.",
  "voice.browseOther": "Jelajahi suara lain",

  "voice.error": "Terjadi kesalahan. Coba lagi",
  "voice.copied": "Disalin ke clipboard!",

  "voice.newer.body":
    "{username} sudah memperbarui suara ini. Coba versi terbarunya",
  "voice.newer.cta": "Versi terbaru",
  "voice.communityFavourite": "Favorit komunitas",
  "voice.uploadedBy": "Diunggah oleh {name}",
  "voice.voices.one": "{n} suara",
  "voice.voices.other": "{n} suara",
  "voice.createCover": "Buat cover · {uses} kali dipakai",
  "voice.like": "Suka suara ini",
  "voice.unlike": "Batal suka",
  "voice.comments": "Komentar",
  "voice.saveToCollection": "Simpan ke koleksi",
  "voice.share": "Bagikan Suara",
  "voice.edit": "Edit Suara",
  "voice.report": "Laporkan Suara",
  "voice.delete": "Hapus Suara",
  "voice.more": "Lainnya",
  "voice.description": "Deskripsi",

  "voice.discord.label": "Ngobrolin {name} bareng komunitas",
  "voice.discord.labelNoName": "Ngobrolin suara AI bareng komunitas",
  "voice.discord.body":
    "Bagikan cover-mu, request suara baru, dan dapatkan tips di Discord",

  "voice.similar.title": "Suara AI Mirip {name}",
  "voice.similar.sub":
    "Pengguna sering memakai suara-suara ini bersama {name}.",
  "voice.similar.moreHub": "Suara {badge} lainnya",
  "voice.popularHub.title": "Suara AI {badge} populer",
  "voice.seeAll": "Lihat semua",
  "voice.collections.title": "Koleksi dengan {name}",
  "voice.collections.titleNoName": "Koleksi dengan Suara Ini",
  "voice.pairWell.title": "Suara yang cocok dipasangkan dengan {name}",

  "voice.about.title": "Tentang Suara AI {name}",
  "voice.about.use":
    "Pakai suara AI {name} untuk membuat cover AI, sebagai pengubah suara, atau untuk teks ke suara.",
  "voice.about.categorised": "Kategorinya: {list}.",
  "voice.about.uses": "Suara ini sudah dipakai {n} kali di Jammable.",
  "voice.howTo.title": "Cara membuat cover AI {name}",

  "voice.faq.title": "FAQ Suara AI {name}",
  "voice.faq.sub": "Semua tentang membuat cover dengan suara {name}.",
  "voice.link.aiCover": "Pembuat Cover AI",
  "voice.link.voiceChanger": "Pengubah Suara AI",
  "voice.link.browseAll": "Jelajahi semua suara AI",
  "voice.link.weights": "Alternatif Weights.gg",
  "voice.faq.how.q": "Bagaimana cara membuat cover AI {name}?",
  "voice.faq.how.a":
    "Untuk membuat cover AI {name}, kamu perlu menambahkan audiomu sendiri di studio (baca {dmca} kami). Setelah itu, tekan konversi! Cover AI {name}-mu akan siap dalam sekitar 30-60 detik.",
  "voice.faq.dmca": "Kebijakan DMCA",
  "voice.faq.input.q": "Audio apa yang bisa kupakai untuk cover AI {name}?",
  "voice.faq.input.a":
    "Kamu hanya boleh mengunggah audio orisinal milikmu sendiri. Jangan memasukkan rekaman suara yang mengandung materi berhak cipta milik pihak ketiga tanpa izin pemiliknya.",
  "voice.faq.time.q": "Berapa lama cover AI {name}-ku jadi?",
  "voice.faq.time.a": "Cover AI {name}-mu akan siap dalam sekitar 30-60 detik!",
  "voice.faq.credits.q": "Berapa kredit yang dipakai setiap cover AI {name}?",
  "voice.faq.credits.a": "Setiap cover AI {name} cuma memakai 1 kredit!",
  "voice.faq.acapella.q": "Apakah aku perlu mengunggah acapella?",
  "voice.faq.acapella.a":
    "Tidak, kamu tidak perlu mengunggah acapella karena sistem kami tetap akan mengekstrak vokalnya untuk cover AI {name}-mu!",
  "voice.faq.changer.q":
    "Apakah suara AI {name} bisa dipakai sebagai pengubah suara?",
  "voice.faq.changer.a":
    "Bisa. Kamu bisa memakai suara AI {name} sebagai pengubah suara atau untuk teks ke suara: unggah atau rekam audiomu, lalu ubah jadi suara {name} dalam hitungan detik.",
  "voice.faq.free.q": "Apakah suara AI {name} gratis?",
  "voice.faq.free.a":
    "Kamu bisa mendengarkan demo suara AI {name} dan menyiapkan cover secara gratis. Untuk membuat cover, kamu perlu paket Jammable, yang memberimu cover AI {name} tanpa batas, download, dan banyak lagi.",

  "voice.demos.title": "Dengarkan dulu",
  "voice.demos.note":
    "Demo dibuat otomatis untuk menunjukkan kualitas suaranya.",
  "voice.demos.maleSinging": "Nyanyian Cowok {n}",
  "voice.demos.femaleSinging": "Nyanyian Cewek {n}",
  "voice.demos.english": "Bahasa Inggris",
  "voice.play": "Putar {name}",
  "voice.pause": "Jeda {name}",

  "voice.library.title": "Lagu dengan suara ini",
  "voice.library.sub":
    "Dengarkan suara AI {name} menyanyikan lagu-lagu populer dari library kami.",
  "voice.library.unknownSong": "Lagu Tidak Dikenal",
  "voice.library.unknownArtist": "Artis Tidak Dikenal",

  "voice.comments.count.one": "{n} komentar",
  "voice.comments.count.other": "{n} komentar",
  "voice.comments.add": "Tambah komentar",
  "voice.comments.post": "Kirim",
  "voice.comments.top": "Teratas",
  "voice.comments.newest": "Terbaru",
  "voice.comments.empty": "Belum ada komentar...",
  "voice.comments.emptySub": "Mulai obrolannya!",
  "voice.comments.more": "Tampilkan komentar lainnya",
  "voice.comments.posted": "Komentar terkirim!",
  "voice.comments.avatarAlt": "Avatar Pengguna",
  "voice.comments.creator": "Kreator",
  "voice.comments.pinned": "Disematkan",
  "voice.comments.reply": "Balas",
  "voice.comments.replyLabel": "Balasan Komentar",
  "voice.comments.replyPlaceholder": "Gimana menurutmu?!",
  "voice.comments.viewReply.one": "Lihat {n} Balasan",
  "voice.comments.viewReply.other": "Lihat {n} Balasan",
  "voice.comments.viewMore": "Lihat {n} Lagi",
  "voice.comments.justNow": "baru saja",
  "voice.comments.minutes": "{n}m",
  "voice.comments.hours": "{n}j",
  "voice.comments.days": "{n}h",
  "voice.comments.repliesFailed": "Gagal memuat balasan",
  "voice.comments.pinnedToast": "Komentar disematkan!",
  "voice.comments.unpinnedToast": "Sematan komentar dilepas!",
  "voice.comments.pinFailed": "Gagal menyematkan komentar",
  "voice.comments.pin": "Sematkan Komentar",
  "voice.comments.unpin": "Lepas Sematan",
  "voice.comments.delete": "Hapus Komentar",
  "voice.comments.report": "Laporkan Komentar",

  "voice.addTo.title": "Tambah ke Koleksi",
  "voice.addTo.error": "Gagal memuat koleksi: {message}",
  "voice.addTo.empty": "Koleksi tidak ditemukan...",
  "voice.addTo.emptySub": "Buat koleksi pertamamu!",
  "voice.addTo.new": "Koleksi Baru",
};

export default voice;
